import React from "react";


function SectionsTitle(props) {
    return (
        <div className="SectionsTitle">{props.text}</div>
    );
}

export default SectionsTitle;